<template>
  <div class="paperCard" ref="root">
    <div class="date">
      <!-- <p class="month">
        <span class="month">{{ data.month }}</span>月
      </p>
      <p class="year">{{ data.year }}年</p> -->
      <img src="@/assets/paper-T.png">
    </div>
    <div class="line" v-for="(item, index) in data" :key="item.Id" @click="$router.push('/studyResult/detail?id=' + encodeURIComponent(item.id)+'&type=paper')">
      <span class="line-l" :title="item.title">{{ item.title }}</span>
      <el-divider direction="vertical"></el-divider>
      <span class="line-c" :title="item.authors">{{ item.authors }}</span>
      <el-divider direction="vertical"></el-divider>
      <span class="line-r" :title="item.publication">{{ item.publication }}，{{ item.date }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'researchCard',
  props: {
    // {year: '', month: '', list: [{title: '', authors: '', publication: ''}, ...]}
    // data: {
    //   type: Object,
    //   required: true
    // },

    // [{title: '', authors: '', publication: '', date: '', id: ''}, ...]
    data: {
      type: Array,
      required: true
    },
    width: {
      type: String,
      default: '880px'
    }
  },
  mounted() {
    // TODO: 不知道是否可以这样处理，因为js中修改样式px2rem不生效
    this.$refs.root.style.width = parseInt(this.width) * 0.8 + 'px'
  }
}
</script>

<style lang="scss" scoped>
  .paperCard {
    position: relative;
    // padding: 50px 10%;
    padding: 50px 150px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.35);
    color: #333;
  }
  .date {
    position: absolute;
    left: 25px;
    top: 25px;
    display: flex;
    flex-direction: column;
    width: 74px;
    img {
      width: 45px;
      height: 45px;
    }
  }
  .line {
    display: flex;
    // justify-content: space-between;
    padding: 0 10px;
    line-height: 65px;
    border-bottom: 2px solid #e9e9e9;
    font-size: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
  .el-divider {
    align-self: center;
    margin: 0 15px;
    width: 2px;
    background-color: #b3b5b9;
  }
  .line-l {
    max-width: 60%;
    @include hideTextOverflow;
  }
  .line-c {
    max-width: 20%;
    text-align: center;
    @include hideTextOverflow;
  }
  .line-r {
    max-width: 20%;
    text-align: right;
    @include hideTextOverflow;
  }
</style>
